import React from 'react';
import ReactDOM from 'react-dom';
import ParsedFroalaHtml from '@/components/shared/ParsedFroalaHtml';
import
SectionTextGlossaryTerm
  from '@/components/shared/Froala/plugins/GlossaryTerms/SectionTextGlossaryTerm/SectionTextGlossaryTerm';

interface NewSectionTextProps {
  html: string;
  sectionTheme:string;
}

const NewSectionText = ({ html, sectionTheme } : NewSectionTextProps) => {
  const handleTextSectionClick = (e : React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const target = e.target as HTMLElement;
    if (target.tagName === 'STRONG' && target.classList.contains('glossary-text')) {
      const termId = parseInt(target.parentElement?.getAttribute('data-term-id'), 10);
      const { parentElement } = target;
      ReactDOM.render(
        <SectionTextGlossaryTerm originalText={target.innerText} termId={termId} />,
        parentElement,
      );
    }
  };

  return (
    <div className="new-section-text" role="document" onClick={handleTextSectionClick}>
      <div className={`fr-view tw-h-auto tw-w-auto ${sectionTheme}`}>
        <ParsedFroalaHtml shouldParse html={html} />
      </div>
    </div>
  );
};

export default NewSectionText;
